module.exports = __webpack_public_path__ + "img/checked.7c7f50bf.png";